import { useCallback, useLayoutEffect, useRef, useState } from "react";

import { getHorizontalScrollStateFromDom } from "../../../../../lib/horizontalScrollState";

const useHorizontalTableScrollState = (heading, rows) => {
  const tableRef = useRef(null);
  const wrapperRef = useRef(null);
  const [scrollState, setScrollState] = useState({
    hasOverflow: false,
    atStart: true,
    atEnd: true
  });

  const updateScrollState = useCallback(() => {
    setScrollState(
      getHorizontalScrollStateFromDom(tableRef.current, wrapperRef.current)
    );
  }, []);

  useLayoutEffect(() => {
    const wrapperElement = wrapperRef.current;
    const tableElement = tableRef.current;

    updateScrollState();

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(updateScrollState)
        : null;

    if (resizeObserver) {
      if (wrapperElement) {
        resizeObserver.observe(wrapperElement);
      }
      if (tableElement) {
        resizeObserver.observe(tableElement);
      }
    }

    window.addEventListener("resize", updateScrollState);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", updateScrollState);
    };
  }, [heading, rows, updateScrollState]);

  return {
    tableRef,
    wrapperRef,
    scrollState,
    updateScrollState
  };
};

export default useHorizontalTableScrollState;
